module.exports = __webpack_public_path__ + "img/shipo-menu-barge-intelligent-system-white.6f88a6e3.svg";